// This file has been generated using @svgr/cli.
// Run "pnpm --filter=@aircall/icons run generate:icons" in order to generate the files for new icons.

import type {
  ColorProps,
  ITheme,
  SystemProp,
  Theme,
} from "@xstyled/styled-components";

import styled, { color, style } from "@xstyled/styled-components";
import type * as React from "react";
import type { StyledComponent } from "styled-components";

interface SizeProps<T extends ITheme = Theme> {
  size?: SystemProp<number | string, T>;
}

const size = style<SizeProps>({
  prop: "size",
  css: ["width", "height"],
});

/**
 * TODO to be removec once the icons has been validated and added to Tractor
 */

interface SvgComponentProps extends SizeProps, ColorProps {}
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 24 25"
    {...props}
  >
    <g clipPath="url(#Virtual-Agent-Filled_svg__a)">
      <path
        fill="currentColor"
        d="M19.436 11.912c-1.677-4.643-3.412-8.41-4.202-9.157a1.4 1.4 0 0 0-.434-.297.7.7 0 0 0-.236-.093c-.512-.168-1.48-.28-2.564-.28s-2.052.113-2.564.28c-.098.037-.178.056-.237.093-.158.074-.295.186-.433.297-.79.728-2.525 4.494-4.202 9.157-1.46 4.064-2.445 7.626-2.564 9.156v.15c0 .503.336.932.809 1.099.71.242 1.913.447 3.47.578.06 0 .14.019.218.019a.75.75 0 0 0 .77-.43c.375-.838 1.163-1.453 2.13-1.658.572-.131 1.538-.205 2.603-.205s2.032.074 2.603.205a2.93 2.93 0 0 1 2.13 1.659c.12.279.415.447.75.429.098 0 .178-.019.237-.019 1.538-.15 2.762-.355 3.471-.578.473-.168.809-.597.809-1.1v-.15c-.119-1.529-1.104-5.09-2.564-9.155m-9.077 2.478a.35.35 0 0 1-.36.34H9.21a.35.35 0 0 1-.36-.34v-3.777a.35.35 0 0 1 .36-.34H10a.35.35 0 0 1 .36.34zm2.396 1.291a.35.35 0 0 1-.36.34h-.79a.35.35 0 0 1-.36-.34v-6.36a.35.35 0 0 1 .36-.34h.79a.35.35 0 0 1 .36.34zm2.395-1.291a.35.35 0 0 1-.36.34H14a.35.35 0 0 1-.36-.34v-3.777a.35.35 0 0 1 .36-.34h.79a.35.35 0 0 1 .36.34z"
      />
    </g>
    <defs>
      <clipPath id="Virtual-Agent-Filled_svg__a">
        <path fill="#fff" d="M2 2h20v21H2z" />
      </clipPath>
    </defs>
  </svg>
);
const SvgVirtualAgentFilled = styled(SvgComponent)<SvgComponentProps>`
  ${size as never}
  ${color as never}
` as StyledComponent<typeof SvgComponent, Theme, SvgComponentProps, never>;
export default SvgVirtualAgentFilled;
